import templateUrl from 'emun.customer/customer-service-notes.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import customerConfig from "emun.customer/customer.config";

class CustomerServiceNotesController {
    constructor($rootScope) { 
        const $ctrl = this;
        basicController($ctrl);
        $ctrl.config = customerConfig;
		$ctrl.views = {
			list: "th-list",
			cards: "th"
		};
		$ctrl.view = "list";
        var bus = $ctrl.bus = new ServiceBus($rootScope);
        if (this.customer) {
            $ctrl.notes = new AutoQuery({
                url: 'QueryCustomerServiceNotes.json?retailerId=' + this.customer.id,
                orderBy: '-CreatedOn',
                autoLoad: true,
                pageSize: $ctrl.view === 'list' ? 10 : 1000
            });
        } 
        $rootScope.$on('customerNoteSaved', () => $ctrl.notes.load(true));
        $rootScope.$on('customerNoteDeleted', () => $ctrl.notes.load(true));
        $ctrl.deleteNote = function(note) {
            return modals.confirm("Are you sure?", "Delete Note").result.then(function () {
                $ctrl.bus.send('DeleteCustomerServiceNote.json', note).then(function (response) {
                    $rootScope.$emit('customerNoteDeleted', $ctrl);
                });
            });
        }
    }
	setView(view) {
		let $ctrl = this;
		$ctrl.view = view;
		if (view === "list") $ctrl.notes.pageSize = 10;
		else if(view === "cards") $ctrl.notes.pageSize = 1000;
		$ctrl.notes.load(true);
	}
}

let CustomerServiceNotes = {
    bindings: {
        customer: '<',
		prospectmode: '<'
    },
    //require: {
    //    container: '^customerDashboard'
    //},
    controller: CustomerServiceNotesController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default CustomerServiceNotes